import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=a2b9436a&scoped=true"
import script from "./UserAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAvatar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UserAvatar.vue?vue&type=style&index=0&id=a2b9436a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b9436a",
  null
  
)

export default component.exports